const state = {
  UserRoleList: null, //角色下拉列表
  LoginNameList: null, //登录账号下拉列表
  LicenseTypeList: null, //号牌种类下拉列表
  GroupList: null, //集团列表
  StationsList: null, //检测站列表
  DetectionTypeList: null, //检测类别
  VehicleCategoryList: null, //车辆类别
  VehicleTypeList: null, //车辆类型
  ChargeTypeList: null, //收费类型列表
  PersonTypeList: null, //人员类型列表
  DeviceTypeList: null, //设备类型列表
  DrivingTypeList: null, //驾驶证类型列表
  InspectionFeeList: null, //检测费用列表
  InspectionServiceFeeList: null, //检测服务费用列表
  EnvironmentalFeeList: null, //环检费用列表
  EnvironmentalServiceFeeList: null, //环检服务费用列表
  AddedCheckBox: null, //增值服务复选框
  GroupTreeList: null, //集团树列表
  FuelTypeList: null, //燃油类型
  UseNatureList: null, //使用性质
  TariffItemList: null, //检测项目
  TariffAdditiveList: null, //附件项目
  TariffPackageList: null, //收费套餐
  MemberList: null, //会员列表
  CouponCategoryList: null, //优惠券品类
  CouponTypeList: null, //优惠券类型            
  CouponFromList: null, //优惠券来源  
  CouponUsingList: null, //优惠券集合状态    
  MiniProgramStatusList: null, //优惠券使用状态
  ChargeCategoryList: null, //收费类别
  WareHouseAdditiveList: null, //库存车检附件项目

}

const getters = {
  UserRoleList(state) {
    return state.UserRoleList || JSON.parse(sessionStorage.getItem("UserRoleList"))
  },
  LoginNameList(state) {
    return state.LoginNameList || JSON.parse(sessionStorage.getItem("LoginNameList"))
  },
  LicenseTypeList(state) {
    return state.LicenseTypeList || JSON.parse(sessionStorage.getItem("LicenseTypeList"))
  },
  GroupList(state) {
    return state.GroupList || JSON.parse(sessionStorage.getItem("GroupList"))
  },
  StationsList(state) {
    return state.StationsList || JSON.parse(sessionStorage.getItem("StationsList"))
  },
  DetectionTypeList(state) {
    return state.DetectionTypeList || JSON.parse(sessionStorage.getItem("DetectionTypeList"))
  },
  VehicleCategoryList(state) {
    return state.VehicleCategoryList || JSON.parse(sessionStorage.getItem("VehicleCategoryList"))
  },
  VehicleTypeList(state) {
    return state.VehicleTypeList || JSON.parse(sessionStorage.getItem("VehicleTypeList"))
  },
  FuelTypeList(state) {
    return state.FuelTypeList || JSON.parse(sessionStorage.getItem("FuelTypeList"))
  },
  UseNatureList(state) {
    return state.UseNatureList || JSON.parse(sessionStorage.getItem("UseNatureList"))
  },
  TariffItemList(state) {
    return state.TariffItemList || JSON.parse(sessionStorage.getItem("TariffItemList"))
  },
  TariffAdditiveList(state) {
    return state.TariffAdditiveList || JSON.parse(sessionStorage.getItem("TariffAdditiveList"))
  },
  TariffPackageList(state) {
    return state.TariffPackageList || JSON.parse(sessionStorage.getItem("TariffPackageList"))
  },
  MemberList(state) {
    return state.MemberList || JSON.parse(sessionStorage.getItem("MemberList"))
  },
  ChargeTypeList(state) {
    return state.ChargeTypeList || JSON.parse(sessionStorage.getItem("ChargeTypeList"))
  },
  PersonTypeList(state) {
    return state.PersonTypeList || JSON.parse(sessionStorage.getItem("PersonTypeList"))
  },
  DeviceTypeList(state) {
    return state.DeviceTypeList || JSON.parse(sessionStorage.getItem("DeviceTypeList"))
  },
  DrivingTypeList(state) {
    return state.DrivingTypeList || JSON.parse(sessionStorage.getItem("DrivingTypeList"))
  },
  InspectionFeeList(state) {
    return state.InspectionFeeList || JSON.parse(sessionStorage.getItem("InspectionFeeList"))
  },
  InspectionServiceFeeList(state) {
    return state.InspectionServiceFeeList || JSON.parse(sessionStorage.getItem("InspectionServiceFeeList"))
  },
  EnvironmentalFeeList(state) {
    return state.EnvironmentalFeeList || JSON.parse(sessionStorage.getItem("EnvironmentalFeeList"))
  },
  EnvironmentalServiceFeeList(state) {
    return state.EnvironmentalServiceFeeList || JSON.parse(sessionStorage.getItem("EnvironmentalServiceFeeList"))
  },
  AddedCheckBox(state) {
    return state.AddedCheckBox || JSON.parse(sessionStorage.getItem("AddedCheckBox"))
  },
  GroupTreeList(state) {
    console.log(JSON.parse(sessionStorage.getItem("GroupTreeList")));
    return state.GroupTreeList || JSON.parse(sessionStorage.getItem("GroupTreeList"))
  },
  CouponCategoryList(state) {
    return state.CouponCategoryList || JSON.parse(sessionStorage.getItem("CouponCategoryList"));
  },
  CouponTypeList(state) {
    return state.CouponTypeList || JSON.parse(sessionStorage.getItem("CouponTypeList"));
  },
  CouponFromList(state) {
    return state.CouponFromList || JSON.parse(sessionStorage.getItem("CouponFromList"));
  },
  CouponUsingList(state) {
    return state.CouponUsingList || JSON.parse(sessionStorage.getItem("CouponUsingList"));
  },
  MiniProgramStatusList(state) {
    return state.MiniProgramStatusList || JSON.parse(sessionStorage.getItem("MiniProgramStatusList"));
  },
  ChargeCategoryList(state) {
    return state.ChargeCategoryList || JSON.parse(sessionStorage.getItem("ChargeCategoryList"))
  },
  WareHouseAdditiveList(state) {
    return state.WareHouseAdditiveList || JSON.parse(sessionStorage.getItem("WareHouseAdditiveList"))
  },
}

const mutations = {
  SAVE_UserRoleList(state, value) {
    state.UserRoleList = value;
    sessionStorage.setItem('UserRoleList', JSON.stringify(value))
  },
  SAVE_LoginNameList(state, value) {
    state.LoginNameList = value;
    sessionStorage.setItem('LoginNameList', JSON.stringify(value))
  },
  SAVE_LicenseTypeList(state, value) {
    state.LicenseTypeList = value;
    sessionStorage.setItem('LicenseTypeList', JSON.stringify(value))
  },
  SAVE_GroupList(state, value) {
    state.GroupList = value;
    sessionStorage.setItem('GroupList', JSON.stringify(value))
  },
  SAVE_StationsList(state, value) {
    state.StationsList = value;
    sessionStorage.setItem('StationsList', JSON.stringify(value))
  },
  SAVE_DetectionTypeList(state, value) {
    state.DetectionTypeList = value;
    sessionStorage.setItem('DetectionTypeList', JSON.stringify(value))
  },
  SAVE_VehicleCategoryList(state, value) {
    state.VehicleCategoryList = value;
    sessionStorage.setItem('VehicleCategoryList', JSON.stringify(value))
  },
  SAVE_VehicleTypeList(state, value) {
    state.VehicleTypeList = value;
    sessionStorage.setItem('VehicleTypeList', JSON.stringify(value))
  },
  SAVE_FuelTypeList(state, value) {
    state.FuelTypeList = value;
    sessionStorage.setItem('FuelTypeList', JSON.stringify(value))
  },
  SAVE_UseNatureList(state, value) {
    state.UseNatureList = value;
    sessionStorage.setItem('UseNatureList', JSON.stringify(value))
  },
  SAVE_TariffItemList(state, value) {
    state.TariffItemList = value;
    sessionStorage.setItem('TariffItemList', JSON.stringify(value))
  },
  SAVE_TariffAdditiveList(state, value) {
    state.TariffAdditiveList = value;
    sessionStorage.setItem('TariffAdditiveList', JSON.stringify(value))
  },
  SAVE_TariffPackageList(state, value) {
    state.TariffPackageList = value;
    sessionStorage.setItem('TariffPackageList', JSON.stringify(value))
  },
  SAVE_MemberList(state, value) {
    state.MemberList = value;
    sessionStorage.setItem('MemberList', JSON.stringify(value))
  },
  SAVE_ChargeTypeList(state, value) {
    state.ChargeTypeList = value;
    sessionStorage.setItem('ChargeTypeList', JSON.stringify(value))
  },
  SAVE_PersonTypeList(state, value) {
    state.PersonTypeList = value;
    sessionStorage.setItem('PersonTypeList', JSON.stringify(value))
  },
  SAVE_DeviceTypeList(state, value) {
    state.DeviceTypeList = value;
    sessionStorage.setItem('DeviceTypeList', JSON.stringify(value))
  },
  SAVE_DrivingTypeList(state, value) {
    state.DrivingTypeList = value;
    sessionStorage.setItem('DrivingTypeList', JSON.stringify(value))
  },
  SAVE_InspectionFeeList(state, value) {
    state.InspectionFeeList = value;
    sessionStorage.setItem('InspectionFeeList', JSON.stringify(value))
  },
  SAVE_InspectionServiceFeeList(state, value) {
    state.InspectionServiceFeeList = value;
    sessionStorage.setItem('InspectionServiceFeeList', JSON.stringify(value))
  },
  SAVE_EnvironmentalFeeList(state, value) {
    state.EnvironmentalFeeList = value;
    sessionStorage.setItem('EnvironmentalFeeList', JSON.stringify(value))
  },
  SAVE_EnvironmentalServiceFeeList(state, value) {
    state.EnvironmentalServiceFeeList = value;
    sessionStorage.setItem('EnvironmentalServiceFeeList', JSON.stringify(value))
  },
  SAVE_AddedCheckBox(state, value) {
    state.AddedCheckBox = value;
    sessionStorage.setItem('AddedCheckBox', JSON.stringify(value))
  },
  SAVE_GroupTreeList(state, value) {
    state.GroupTreeList = value;
    // console.log('saveTree');
    // console.log(state.GroupTreeList);
    sessionStorage.setItem('GroupTreeList', JSON.stringify(value))
  },
  SAVE_CouponCategoryList(state, value) {
    state.CouponCategoryList = value;
    sessionStorage.setItem('CouponCategoryList', JSON.stringify(value));
  },
  SAVE_CouponTypeList(state, value) {
    state.CouponTypeList = value;
    sessionStorage.setItem('CouponTypeList', JSON.stringify(value));
  },
  SAVE_CouponFromList(state, value) {
    state.CouponFromList = value;
    sessionStorage.setItem('CouponFromList', JSON.stringify(value));
  },
  SAVE_CouponUsingList(state, value) {
    state.CouponUsingList = value;
    sessionStorage.setItem('CouponUsingList', JSON.stringify(value));
  },
  SAVE_MiniProgramStatusList(state, value) {
    state.MiniProgramStatusList = value;
    sessionStorage.setItem('MiniProgramStatusList', JSON.stringify(value));
  },
  SAVE_ChargeCategoryList(state, value) {
    state.ChargeCategoryList = value;
    sessionStorage.setItem('ChargeCategoryList', JSON.stringify(value));
  },
  SAVE_WareHouseAdditiveList(state, value) {
    state.WareHouseAdditiveList = value;
    sessionStorage.setItem('WareHouseAdditiveList', JSON.stringify(value));
  },

  REMOVE_UserRoleList(state) {
    sessionStorage.removeItem('UserRoleList')
    state.UserRoleList = null;
  },
  REMOVE_LoginNameList(state) {
    sessionStorage.removeItem('LoginNameList')
    state.LoginNameList = null;
  },
  REMOVE_LicenseTypeList(state) {
    sessionStorage.removeItem('LicenseTypeList')
    state.LicenseTypeList = null;
  },
  REMOVE_GroupList(state) {
    sessionStorage.removeItem('GroupList')
    state.GroupList = null;
  },
  REMOVE_StationsList(state) {
    sessionStorage.removeItem('StationsList')
    state.StationsList = null;
  },
  REMOVE_DetectionTypeList(state) {
    sessionStorage.removeItem('DetectionTypeList')
    state.DetectionTypeList = null;
  },
  REMOVE_VehicleCategoryList(state) {
    sessionStorage.removeItem('VehicleCategoryList')
    state.VehicleCategoryList = null;
  },
  REMOVE_VehicleTypeList(state) {
    sessionStorage.removeItem('VehicleTypeList')
    state.VehicleTypeList = null;
  },
  REMOVE_FuelTypeList(state) {
    sessionStorage.removeItem('FuelTypeList')
    state.FuelTypeList = null;
  },
  REMOVE_UseNatureList(state) {
    sessionStorage.removeItem('UseNatureList')
    state.UseNatureList = null;
  },
  REMOVE_TariffItemList(state) {
    sessionStorage.removeItem('TariffItemList')
    state.TariffItemList = null;
  },
  REMOVE_TariffAdditiveList(state) {
    sessionStorage.removeItem('TariffAdditiveList')
    state.TariffAdditiveList = null;
  },
  REMOVE_TariffPackageList(state) {
    sessionStorage.removeItem('TariffPackageList')
    state.TariffPackageList = null;
  },
  REMOVE_MemberList(state) {
    sessionStorage.removeItem('MemberList')
    state.MemberList = null;
  },
  REMOVE_ChargeTypeList(state) {
    sessionStorage.removeItem('ChargeTypeList')
    state.ChargeTypeList = null;
  },
  REMOVE_PersonTypeList(state) {
    sessionStorage.removeItem('PersonTypeList')
    state.PersonTypeList = null;
  },
  REMOVE_DeviceTypeList(state) {
    sessionStorage.removeItem('DeviceTypeList')
    state.DeviceTypeList = null;
  },
  REMOVE_DrivingTypeList(state) {
    sessionStorage.removeItem('DrivingTypeList')
    state.DrivingTypeList = null;
  },
  REMOVE_InspectionFeeList(state) {
    sessionStorage.removeItem('InspectionFeeList')
    state.InspectionFeeList = null;
  },
  REMOVE_InspectionServiceFeeList(state) {
    sessionStorage.removeItem('InspectionServiceFeeList')
    state.InspectionServiceFeeList = null;
  },
  REMOVE_EnvironmentalFeeList(state) {
    sessionStorage.removeItem('EnvironmentalFeeList')
    state.EnvironmentalFeeList = null;
  },
  REMOVE_EnvironmentalServiceFeeList(state) {
    sessionStorage.removeItem('EnvironmentalServiceFeeList')
    state.EnvironmentalServiceFeeList = null;
  },
  REMOVE_AddedCheckBox(state) {
    sessionStorage.removeItem('AddedCheckBox')
    state.AddedCheckBox = null;
  },
  REMOVE_GroupTreeList(state) {
    sessionStorage.removeItem('GroupTreeList')
    state.GroupTreeList = null;
  },
  REMOVE_CouponCategoryList() {
    sessionStorage.removeItem('CouponCategoryList')
    state.CouponCategoryList = null;
  },
  REMOVE_CouponTypeList() {
    sessionStorage.removeItem('CouponTypeList')
    state.CouponTypeList = null;
  },
  REMOVE_CouponFromList() {
    sessionStorage.removeItem('CouponFromList')
    state.CouponFromList = null;
  },
  REMOVE_CouponUsingList() {
    sessionStorage.removeItem('CouponUsingList')
    state.CouponUsingList = null;
  },
  REMOVE_MiniProgramStatusList() {
    sessionStorage.removeItem('MiniProgramStatusList')
    state.MiniProgramStatusList = null;
  },
  REMOVE_ChargeCategoryList() {
    sessionStorage.removeItem('ChargeCategoryList')
    state.ChargeCategoryList = null;
  },
  REMOVE_WareHouseAdditiveList() {
    sessionStorage.removeItem('WareHouseAdditiveList')
    state.WareHouseAdditiveList = null;
  },
}

const actions = {
  saveUserRoleList(context, value) {
    context.commit('SAVE_UserRoleList', value)
  },
  saveLoginNameList(context, value) {
    context.commit('SAVE_LoginNameList', value)
  },
  saveLicenseTypeList(context, value) {
    context.commit('SAVE_LicenseTypeList', value)
  },
  saveGroupList(context, value) {
    context.commit('SAVE_GroupList', value)
  },
  saveStationsList(context, value) {
    context.commit('SAVE_StationsList', value)
  },
  saveDetectionTypeList(context, value) {
    context.commit('SAVE_DetectionTypeList', value)
  },
  saveVehicleCategoryList(context, value) {
    context.commit('SAVE_VehicleCategoryList', value)
  },
  saveVehicleTypeList(context, value) {
    context.commit('SAVE_VehicleTypeList', value)
  },
  saveFuelTypeList(context, value) {
    context.commit('SAVE_FuelTypeList', value)
  },
  saveUseNatureList(context, value) {
    context.commit('SAVE_UseNatureList', value)
  },
  saveTariffItemList(context, value) {
    context.commit('SAVE_TariffItemList', value)
  },
  saveTariffAdditiveList(context, value) {
    context.commit('SAVE_TariffAdditiveList', value)
  },
  saveTariffPackageList(context, value) {
    context.commit('SAVE_TariffPackageList', value)
  },
  saveMemberList(context, value) {
    context.commit('SAVE_MemberList', value)
  },
  saveChargeTypeList(context, value) {
    context.commit('SAVE_ChargeTypeList', value)
  },
  savePersonTypeList(context, value) {
    context.commit('SAVE_PersonTypeList', value)
  },
  saveDeviceTypeList(context, value) {
    context.commit('SAVE_DeviceTypeList', value)
  },
  saveDrivingTypeList(context, value) {
    context.commit('SAVE_DrivingTypeList', value)
  },
  saveInspectionFeeList(context, value) {
    context.commit('SAVE_InspectionFeeList', value)
  },
  saveInspectionServiceFeeList(context, value) {
    context.commit('SAVE_InspectionServiceFeeList', value)
  },
  saveEnvironmentalFeeList(context, value) {
    context.commit('SAVE_EnvironmentalFeeList', value)
  },
  saveEnvironmentalServiceFeeList(context, value) {
    context.commit('SAVE_EnvironmentalServiceFeeList', value)
  },
  saveAddedCheckBox(context, value) {
    context.commit('SAVE_AddedCheckBox', value)
  },
  saveGroupTreeList(context, value) {
    context.commit('SAVE_GroupTreeList', value)
  },
  saveCouponCategoryList(context, value) {
    context.commit('SAVE_CouponCategoryList', value);
  },
  saveCouponTypeList(context, value) {
    context.commit('SAVE_CouponTypeList', value);
  },
  saveCouponFromList(context, value) {
    context.commit('SAVE_CouponFromList', value);
  },
  saveCouponUsingList(context, value) {
    context.commit('SAVE_CouponUsingList', value);
  },
  saveMiniProgramStatusList(context, value) {
    context.commit('SAVE_MiniProgramStatusList', value);
  },
  saveChargeCategoryList(context, value) {
    context.commit('SAVE_ChargeCategoryList', value);
  },
  saveWareHouseAdditiveList(context, value) {
    context.commit('SAVE_WareHouseAdditiveList', value);
  },

  removeUserRoleList(context) {
    context.commit('REMOVE_UserRoleList')
  },
  removeLoginNameList(context) {
    context.commit('REMOVE_LoginNameList')
  },
  removeLicenseTypeList(context) {
    context.commit('REMOVE_LicenseTypeList')
  },
  removeGroupList(context) {
    context.commit('REMOVE_GroupList')
  },
  removeStationsList(context) {
    context.commit('REMOVE_StationsList')
  },
  removeDetectionTypeList(context) {
    context.commit('REMOVE_DetectionTypeList')
  },
  removeVehicleCategoryList(context) {
    context.commit('REMOVE_VehicleCategoryList')
  },
  removeVehicleTypeList(context) {
    context.commit('REMOVE_VehicleTypeList')
  },
  removeTariffItemList(context) {
    context.commit('REMOVE_TariffItemList')
  },
  removeTariffAdditiveList(context) {
    context.commit('REMOVE_TariffAdditiveList')
  },
  removeTariffPackageList(context) {
    context.commit('REMOVE_TariffPackageList')
  },
  removeMemberList(context) {
    context.commit('REMOVE_MemberList')
  },
  removeChargeTypeList(context) {
    context.commit('REMOVE_ChargeTypeList')
  },
  removePersonTypeList(context) {
    context.commit('REMOVE_PersonTypeList')
  },
  removeDeviceTypeList(context) {
    context.commit('REMOVE_DeviceTypeList')
  },
  removeDrivingTypeList(context) {
    context.commit('REMOVE_DrivingTypeList')
  },
  removeInspectionFeeList(context) {
    context.commit('REMOVE_InspectionFeeList')
  },
  removeInspectionServiceFeeList(context) {
    context.commit('REMOVE_InspectionServiceFeeList')
  },
  removeEnvironmentalFeeList(context) {
    context.commit('REMOVE_EnvironmentalFeeList')
  },
  removeEnvironmentalServiceFeeList(context) {
    context.commit('REMOVE_EnvironmentalServiceFeeList')
  },
  removeAddedCheckBox(context) {
    context.commit('REMOVE_AddedCheckBox')
  },
  removeGroupTreeList(context) {
    context.commit('REMOVE_GroupTreeList')
  },
  removeCouponCategoryList() {
    context.commit('REMOVE_CouponCategoryList');
  },
  removeCouponTypeList() {
    context.commit('REMOVE_CouponTypeList');
  },
  removeCouponFromList() {
    context.commit('REMOVE_CouponFromList');
  },
  removeCouponUsingList() {
    context.commit('REMOVE_CouponUsingList');
  },
  removeMiniProgramStatusList() {
    context.commit('REMOVE_MiniProgramStatusList');
  },
  removeChargeCategoryList() {
    context.commit('REMOVE_ChargeCategoryList');
  },
  removeWareHouseAdditiveList() {
    context.commit('REMOVE_WareHouseAdditiveList');
  },

  removeAll(context) {
    context.commit('REMOVE_UserRoleList')
    context.commit('REMOVE_LoginNameList')
    context.commit('REMOVE_LicenseTypeList')
    context.commit('REMOVE_GroupList')
    context.commit('REMOVE_StationsList')
    context.commit('REMOVE_DetectionTypeList')
    context.commit('REMOVE_VehicleCategoryList')
    context.commit('REMOVE_VehicleTypeList')
    context.commit('REMOVE_FuelTypeList')
    context.commit('REMOVE_UseNatureList')
    context.commit('REMOVE_TariffItemList')
    context.commit('REMOVE_TariffAdditiveList')
    context.commit('REMOVE_TariffPackageList')
    context.commit('REMOVE_MemberList')
    context.commit('REMOVE_ChargeTypeList')
    context.commit('REMOVE_PersonTypeList')
    context.commit('REMOVE_DeviceTypeList')
    context.commit('REMOVE_DrivingTypeList')
    context.commit('REMOVE_InspectionFeeList')
    context.commit('REMOVE_InspectionServiceFeeList')
    context.commit('REMOVE_EnvironmentalFeeList')
    context.commit('REMOVE_EnvironmentalServiceFeeList')
    context.commit('REMOVE_AddedCheckBox')
    context.commit('REMOVE_GroupTreeList')
    context.commit('REMOVE_CouponCategoryList')
    context.commit('REMOVE_CouponTypeList')
    context.commit('REMOVE_CouponFromList')
    context.commit('REMOVE_CouponUsingList')
    context.commit('REMOVE_MiniProgramStatusList')
    context.commit('REMOVE_ChargeCategoryList')
    context.commit('REMOVE_WareHouseAdditiveList')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/js/store/modules/dropDown.js